// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2KEdg","colBig":"styles_colBig__1kUam","colSmall":"styles_colSmall__1XVtx"};